export default {
	initialFormState: {
		name: "",
		target: "100",
		units: "%",
		startDate: new Date(),
		dueDate: "",
		description: "",
		category: [],
		assignment: "",
		transparency: {
			value: "public",
			label: "Public",
		},
		alignment: "",
		checklist: [],
		isTopGoal: false,
		weight: "",
	},
	initialPageState: {
		initialized: false,
		formType: "simple",
		permissionModal: {
			display: false,
			message: "",
		},
		bulkAssignmentSelectionObjectID: null,
		bulkAssignmentSelectionObjectCount: 0,
		// when editing a goal, used to store the name of the goal that is being copied
		existingGoalName: "",
	},
	pageName: "",
	formInputOptions: {
		transparencyOptions: [
			{ value: "public", label: "Public" },
			{ value: "private", label: "Private" },
		],
	},
	transparencyLookup: {
		public: "Public",
		private: "Private",
	},
};
